// PageDrivers.jsx
import React from "react";

// Reusable card
const TeamCard = ({ member }) => (
  <div className="col-lg-3 col-md-6">
    {/* Team Member Item Start */}
    <div className="team-member-item wow fadeInUp" data-wow-delay={member.delay || undefined}>
      {/* Team Image Start */}
      <div className="team-image">
        <figure className="image-anime">
          <img src={member.image} alt={member.name} />
        </figure>

      
       
      </div>
    
    </div>
   
  </div>
);

// Page section
const Ourstaff = () => {
  const team = [
  


    {
      image: "/images/staff/1.jpeg",
      delay: "1s",
      social: { facebook: "#", youtube: "#", instagram: "#", twitter: "#" },
    },
    {
      image: "/images/staff/2.jpeg",
      delay: "1.2s",
      social: { facebook: "#", youtube: "#", instagram: "#", twitter: "#" },
    },
    {
      image: "/images/staff/3.jpeg",
      delay: "1.4s",
      social: { facebook: "#", youtube: "#", instagram: "#", twitter: "#" },
    },
        {
      image: "/images/staff/4.jpeg",
      delay: "1s",
      social: { facebook: "#", youtube: "#", instagram: "#", twitter: "#" },
    },
 
  ];

  return (
    <>

 <div className="page-header bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                 Our Office staff
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div> 

      {/* Page Drivers Start */}
      <div className="page-drivers">
        <div className="container">
          <div className="row">
            {team.map((m, idx) => (
              <TeamCard key={idx} member={m} />
            ))}
          </div>
        </div>
      </div>
      {/* Page Drivers End */}
    </>
  );
};

export default Ourstaff;
